<div class="app-header">
  <div class="right-header-section">
    <div *ngIf="appService.showEngagements">
      <nz-select
        nzPlaceHolder="Select Engagement"
        nzSize="large"
        [formControl]="activeEngagement"
        [nzLoading]="isLoading"
        class="engagement-select"
      >
        <nz-option
          [nzLabel]="engagement.name"
          [nzValue]="engagement.value"
          *ngFor="let engagement of engagementList; index as i"
          nzCustomContent
        >
          <div class="engagement-options">
            <span>{{ engagement.name }}</span>
            <nz-tag [nzColor]="getStatusColor(engagement.status)">{{ getStatusDisplayName(engagement.status) }}</nz-tag>
          </div>
        </nz-option>
      </nz-select>
    </div>
    <div class="user-profile" *ngIf="userEmail">
      <nz-avatar [nzText]="userEmail.at(0)"></nz-avatar>
      <div nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
        <div class="user-info">
          <div>
            {{ userEmail }}
            <nz-tag [nzColor]="orgTypeColor">{{ userOrgType | uppercase }}</nz-tag>
            <span nz-icon nzType="down" class="down-icon"></span>
          </div>
          <div class="user-role">Role: {{ userRole }}</div>
        </div>
      </div>

      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="logout()">Logout</li>
        </ul>
      </nz-dropdown-menu>
    </div>
  </div>
</div>
